import { Box, Grid, Paper, Typography } from "@mui/material"

import { ACTOR_META, SUMMARY_PILLARS, SUMMARY_STATS } from "./guideContent"
import { Card, GuideSection } from "./guideParts"

const PILLAR_COLORS = [ACTOR_META.agent.color, "#006D75", ACTOR_META.host.color]

export default function SummarySection() {
  return (
    <GuideSection
      id="summary"
      eyebrow="Başlangıç"
      title="Tek cümlede v2"
      lead="v2, müşteriye cevabı tek bir yapay zekâ ajanıyla yazar: ajan ihtiyaç duyduğu araçları kendisi kullanır, hangi araçların açık olduğuna ve cevabın gidip gitmeyeceğine ise kod karar verir."
    >
      <Grid container spacing={2}>
        {SUMMARY_PILLARS.map((pillar, index) => (
          <Grid item xs={12} md={4} key={pillar.title}>
            <Card accent={PILLAR_COLORS[index]}>
              <Typography variant="subtitle1" sx={{ fontWeight: 900, mb: 1 }}>
                {pillar.title}
              </Typography>
              <Typography
                variant="body2"
                sx={{ color: "text.secondary", lineHeight: 1.6 }}
              >
                {pillar.body}
              </Typography>
            </Card>
          </Grid>
        ))}
      </Grid>

      <Paper
        variant="outlined"
        sx={{
          mt: 2,
          borderRadius: 2,
          display: "grid",
          gridTemplateColumns: { xs: "1fr", md: "repeat(3, 1fr)" }
        }}
      >
        {SUMMARY_STATS.map((stat, index) => (
          <Box
            key={stat.label}
            sx={{
              p: 2.5,
              borderLeft: { md: index ? 1 : 0 },
              borderTop: { xs: index ? 1 : 0, md: 0 },
              borderColor: "divider"
            }}
          >
            <Typography variant="caption" color="text.secondary">
              {stat.label}
            </Typography>
            <Typography variant="h6" sx={{ fontWeight: 900 }}>
              {stat.value}
            </Typography>
            <Typography variant="caption" color="text.secondary">
              {stat.before}
            </Typography>
          </Box>
        ))}
      </Paper>
    </GuideSection>
  )
}
